module.exports = __webpack_public_path__ + "static/media/22_hero_desktop.7a72906b.jpg";